// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___22Fqc","text":"style__text___3K1Bz","close":"style__close___1jhz6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payments/Notification/style.scss
// module id = 1447
// module chunks = 0